define('konnekt/outsystems/cookie-consent',[
	"cookies",
	"util/channel",
	"./frame-tools",
], function( Cookies, Channel, Frame ) {

	"use strict";

	var
		win      = window,
		location = win.location,
		document = win.document;

	var IS_POPPED_1ST_PARTY =
			   ( win.opener != null )
			&& ( win.opener != win.top )
			&& ( win        == win.top );

	// When open as a first-party, write a cookie that will enable
	// further cookie manipulation under the "when visited before"
	// cookie policy setting of Safari and Chrome, notify the opener
	// and close self.
	if ( IS_POPPED_1ST_PARTY ) {
		Cookies.set( "konnekt-3pc", "ok", { expires : Infinity });
		new Channel({ remote : win.opener, name : "konnekt-3pc" })
			.open()
			.dispatch( "3pc", Cookies.enabled );

		win.close();

		// Don't do anything
		return function() { }
	}

	return function( selector, target ) {
		var
			consent = document.querySelector( ".kk-consent" ),
			button  = consent.querySelector( "button" ),
			channel = new Channel({
				remote : win.parent, // the client website
				name   : "konnekt-3pc"
			}).open();

		// We're going to be waiting for user-input instad of running through
		// a redirect immediately, so let the client site know that the frame
		// is ready.
		Frame.ready();

		function finalizeConsent( has_3pc ) {
			channel.dispatch( "3pc", has_3pc );
			if ( has_3pc ) { location.replace( target ) }
		}

		// When running as a third party and cookies are already enabled,
		// load the target URL and send back a message to the integration
		// script running in the client website that cookies are enabled.
		if ( Cookies.enabled ) {
			finalizeConsent( true );
			return;
		}

		consent.style.display = "";
		button.addEventListener( "click", function handler() {
			button.removeEventListener( "click", handler );

			new Channel({ remote : win.open( location.href ), name : "konnekt-3pc" })
				.listen( "3pc", finalizeConsent )
				.open();
		});
	};

});
